import { MutableRefObject } from "react"
import { DropFrame } from "./types"

function drawImageScaled(
  img: HTMLImageElement,
  ctx: CanvasRenderingContext2D,
  cover: boolean
) {
  //scale dependant on ratio of canvas
  const canvas = ctx.canvas
  const hRatio = canvas.width / img.width
  const vRatio = canvas.height / img.height
  const ratio = cover ? Math.max(hRatio, vRatio) : Math.min(hRatio, vRatio)
  const centerShift_x = (canvas.width - img.width * ratio) / 2
  const centerShift_y = (canvas.height - img.height * ratio) / 2
  ctx.clearRect(0, 0, canvas.width, canvas.height)
  ctx.drawImage(
    img,
    0,
    0,
    img.width,
    img.height,
    centerShift_x,
    centerShift_y,
    img.width * ratio,
    img.height * ratio
  )
}

export function dropRender(
  dropContext: CanvasRenderingContext2D,
  ref: MutableRefObject<HTMLCanvasElement>,
  dropImages: HTMLImageElement[],
  drop: DropFrame,
  setCount: (n: number) => void
) {
  setCount(drop.dropFrame)
  dropContext.clearRect(0, 0, ref?.current?.width, ref?.current?.height)
  drawImageScaled(dropImages[drop.dropFrame], dropContext, true)
}

export function wrapImageUrlWithNextImageParams(url: string, width: number) {
  return `_next/image?url=${encodeURIComponent(url)}&w=${width}&q=80`
}
